module.exports = __webpack_public_path__ + "img/Clear Icon - charcoal.72dde7b3.svg";